import { useQueryLoader } from "react-relay"
import { graphql } from "relay-runtime"
import { useChatMessagesQuery } from "@/modules/chats/services/__generated__/useChatMessagesQuery.graphql"

const ChatMessagesConnectionKey = "ChatMessages_chatMessages"

const chatMessagesQuery = graphql`
  query useChatMessagesQuery($threadId: String!) {
    chatMessages(threadId: $threadId, first: null) @connection(key: "ChatMessages_chatMessages") {
      edges {
        node {
          ...ChatMessageFragment @relay(mask: false)
        }
      }
    }
  }
`

const useChatMessagesQueryLoader = () => useQueryLoader<useChatMessagesQuery>(chatMessagesQuery)

export { chatMessagesQuery, ChatMessagesConnectionKey, useChatMessagesQueryLoader }
